import { render } from "./Slick.vue?vue&type=template&id=4fb582b1"
import script from "./Slick.vue?vue&type=script&lang=js"
export * from "./Slick.vue?vue&type=script&lang=js"

import "./Slick.vue?vue&type=style&index=0&id=4fb582b1&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__